
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./studio": function() {
return __webpack_require__.e(/*  | __federation_expose_studio */ "599").then(function() { return function() { return __webpack_require__(37316); }; });
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };